// Convert a YouTube / Vimeo / direct video URL into an embeddable form.
// Returns { kind: "youtube"|"vimeo"|"file"|"none", embedSrc, raw }.
export function parseVideoUrl(url) {
  const raw = (url || "").trim();
  if (!raw) return { kind: "none", embedSrc: null, raw };

  // YouTube (watch, youtu.be, shorts, embed)
  const yt =
    raw.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
  if (yt) {
    return { kind: "youtube", embedSrc: `https://www.youtube.com/embed/${yt[1]}`, raw };
  }
  // Vimeo
  const vm = raw.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) {
    return { kind: "vimeo", embedSrc: `https://player.vimeo.com/video/${vm[1]}`, raw };
  }
  // Direct video file
  if (/\.(mp4|webm|ogg|mov|m4v)(\?.*)?$/i.test(raw)) {
    return { kind: "file", embedSrc: raw, raw };
  }
  return { kind: "none", embedSrc: raw, raw };
}
